export const scrollToTop = (top?: number) => {
  window.scrollTo({
    top: top || 0,
    behavior: 'smooth',
  });
};
